<template>
  <v-container class="pa-0">
    <template v-if="hasPresetData">
      <!--load preset-->
      <div v-if="hasPresetSelectData">
        <v-select
          :items="presetData.selectData_ar"
          v-model="preset_qlfId_ar"
          prepend-icon="mdi-card-account-details-outline"
          label="Läs in chaufförsprofil"
          @change="doPreset()"
        ></v-select>
      </div>
      <!--save preset-->
      <div>
        <v-checkbox
          v-model="presetData.newQprData.save"
          label="Skapa ny chaufförsprofil utifrån valda kvalifikationer"
          class="pl-0 pr-6"
        ></v-checkbox>
        <v-text-field
          type="text"
          outlined
          prepend-icon="mdi-card-account-details-outline"
          v-if="presetData.newQprData.save"
          v-model="presetData.newQprData.name"
          color="accent"
          maxlength="25"
          label="Namn på chaufförsprofil"
          :rules="presetData.newQprData.save ? [formRules.required] : []"
          validate-on-blur
          :required="presetData.newQprData.save"
        ></v-text-field>
      </div>
    </template>
    <div
      v-for="qualificationAreaData in data.qualificationAreaData_ar"
      :key="qualificationAreaData.id"
    >
      <div class="text-subtitle-1">{{ qualificationAreaData.name }}</div>
      <!--options-->
      <template
        v-if="qualificationAreaData.inputMode == 'options'"
      >
        <v-divider></v-divider>
        <v-row
          justify="start"
          class="pb-8"
        >
          <v-checkbox
            v-for="optionData in qualificationAreaData.optionData_ar"
            :key="optionData.value"
            v-model="data.qlfId_ar"
            :hide-details="true"
            :value="optionData.value"
            :label="optionData.name + ''"
            :rules="qlfRules"
            class="pl-2 pr-6"
            @click.native="onOptionClick(qualificationAreaData)"
          ></v-checkbox>
        </v-row>
      </template>
      <template v-if="mode == 'matching'">
        <!--mode: matching-->
        <!--text-->
        <v-row
          v-if="qualificationAreaData.inputMode == 'text'"
        >
          <v-col>
            <v-text-field
              type="text"
              outlined
              v-model="qualificationAreaData.input"
              maxlength="255"
              :placeholder="qualificationAreaData.placeholder"
            ></v-text-field>
          </v-col>
        </v-row>
        <template v-if="qualificationAreaData.shouldShowFileUpload"> 
          <div class="text-subtitle-2">Intyg för {{ qualificationAreaData.name }}</div>
          <!--general files per qar-->
          <v-row>
            <!--list existing files-->
            <v-col class="pa-0">
              <div
                v-if="qualificationAreaData.qdfData_ar.length"
                class="pb-4"
              >
                <v-chip
                  class="ma-2"
                  color="secondary"
                  label
                  v-for="(qdfData, index) in qualificationAreaData.qdfData_ar"
                  :key="index"
                  close
                  @click="s3_openFile('driver', qdfData)"
                  @click:close="deleteFile(qualificationAreaData, index, 'qdf')"
                >
                  <v-avatar left>
                    <v-icon>mdi-{{ qdfData.icon }}</v-icon>
                  </v-avatar>
                  {{ qdfData.title }}
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <!--file upload-->
          <v-row
            v-for="(newFileRow, index) in newFileRows[qualificationAreaData.id]"
            :key="index"
          >
            <v-col cols="12" sm="6" class="pb-0">
              <!--file field-->
              <v-file-input
                v-model="newFileRow.file"
                color="accent"
                :label="'Ladda upp intyg nr ' + (index + 1)"
                accept="application/pdf,image/*,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                placeholder="Välj fil"
                prepend-icon="mdi-paperclip"
                outlined
                :show-size="true"
                @change="onNewFileInputChange(index, newFileRows[qualificationAreaData.id])"
              >
              </v-file-input>
            </v-col>
            <v-col cols="12" sm="6" class="pb-0">
              <v-text-field
                type="text"
                outlined
                v-model="newFileRow.title"
                color="accent"
                maxlength="40"
                :label="'Namn på intyg nr ' + (index + 1)"
                placeholder="Namnge intyget"
                @change="onNewFileNameChange(index, newFileRows[qualificationAreaData.id])"
                :rules="newFileRow.file !== undefined ? [formRules.required] : []"
                validate-on-blur
                :required="newFileRow.file !== undefined"
              ></v-text-field>
            </v-col>
          </v-row>
        </template>
        <!--OLD multi input field with no naming possibility
        <v-file-input
          v-model="fileUploadData.qar[qualificationAreaData.id]"
          color="accent"
          counter
          label="Ladda upp intyg"
          multiple
          accept="application/pdf,image/*,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          placeholder="Välj fil/er"
          prepend-icon="mdi-paperclip"
          outlined
          :show-size="1000"
        >
          <template v-slot:selection="{ index, text }">
            <v-chip
              v-if="index < 2"
              color="accent"
              dark
              label
              small
            >
              {{ text }}
            </v-chip>

            <span
              v-else-if="index === 2"
              class="overline grey--text text--darken-3 mx-2"
            >
              +{{ fileUploadData.qar[qualificationAreaData.id].length - 2 }} fil/er
            </span>
          </template>
        </v-file-input>
        -->
      </template>
    </div>
    <!--removeFileDialog-->
    <v-dialog
      v-model="removeFileDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Ta bort intyg</v-card-title>
        <v-card-text>
          Vill du verkligen ta bort intyget?
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="removeFileDialog = false"
          >
            Nej
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="doDeleteFile()"
          >
            Ja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import { s3Mixin } from '../mixins/s3'
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { mapGetters } from 'vuex'
import { snackBarBus } from '../main'

export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      required: true
    },
    newFileRows: {
      type: Object,
      required: false
    },
    presetData: {
      type: Object,
      required: false
    },
    emitOptionClick: {
      type: Boolean,
      default: false
    }
    /*
    elementData: {
      type: Object,
      required: true
    }
    */
  },
  mixins: [generalMixin, urlMixin, s3Mixin],
  data: () => ({
    removeFileDialog: false,
    fileDataToRemove: null,
    preset_qlfId_ar: [],
  }),
  computed: {
    ...mapGetters(['access_token']),
    qlfRules() {
      switch(this.mode) {
        case 'assignment':
        case 'qualificationPreset':
          return [this.formRules.checked(this.data.qlfId_ar, 'Minst ett val måste kryssas')]
      }
      return []
    },
    hasPresetData() {
      return !!this.presetData
    },
    hasPresetSelectData() {
      return this.hasPresetData && !!this.presetData.selectData_ar.length
    }
  },
  methods: {
    onOptionClick(qualificationAreaData) {
      //possibly reset qualificationAreaData.shouldShowFileUpload
      if (qualificationAreaData.hasFileUpload && qualificationAreaData.inputMode == 'options') {
        //check any of the options are checked
        let anyChecked = false
        let isChecked
//        console.log('qlfId_ar', this.data.qlfId_ar)
        for (let optionData of qualificationAreaData.optionData_ar) {
          isChecked = this.data.qlfId_ar.indexOf(optionData.value) !== -1
//          console.log('checking - ' + optionData.value, isChecked)
          if (isChecked) {
            anyChecked = true
          }
        }
        qualificationAreaData.shouldShowFileUpload = anyChecked
      }
//      console.log('shouldShowFileUpload', qualificationAreaData.shouldShowFileUpload)
      if (this.emitOptionClick) {
        this.$emit('onOptionClick')
      }
    },
    doPreset() {
      this.data.qlfId_ar = [...this.preset_qlfId_ar]
      this.preset_qlfId_ar = []
    },
    onNewFileInputChange(index, ar) {
      this.arrangeFileInputRowOutput(index, ar)
    },
    onNewFileNameChange(index, ar) {
      this.arrangeFileInputRowOutput(index, ar)
    },
    ensureNewFileInputRow(ar) {
      if (ar.length === 0 || ar[ar.length -1].file !== undefined) {
        //no rows exists OR the last one has a file defined
        ar.push({
          file: undefined,
          title: ''
        })
      }
    },
    arrangeFileInputRowOutput(index, ar) {
//      console.log('arrangeFileInputRowOutput', ar)
      //get array with indexes for blank rows
      let blankIndex_ar = []
      for (index in ar) {
        if (this.isBlankFileInputRow(ar[index])) {
          blankIndex_ar.push(index)
        }
      }
      //now remove those index by looping the blankIndex_ar backwards, otherwise we mess up the index order in ar, resulting in removing the wrong indexes
      for (let i = blankIndex_ar.length - 1; i >= 0; i--) {
        ar.splice(blankIndex_ar[i], 1)
      }
      //now ensure a blank row at the end
      this.ensureNewFileInputRow(ar)
      /*
      //as long as the two last rows are blank, we can remove the last one
      while (ar.length > 1 && this.isBlankFileInputRow(ar[ar.length - 1]) && this.isBlankFileInputRow(ar[ar.length - 2])) {
        //remove the last row in array, cause it is blank
        ar.pop()
      }
      */
    },
    isBlankFileInputRow(item) {
      let isBlank = item.file === undefined && item.title.trim().length == 0
      console.log('isBlankFileInputRow - isBlank:' + isBlank, item)
      return isBlank
    },
    deleteFile(qualificationAreaData, index, mode) {
      this.fileDataToRemove = {
        qdfData_ar: qualificationAreaData.qdfData_ar,
        index: index,
        mode: mode
      }
      this.removeFileDialog = true
    },
    doDeleteFile() {
      console.log('fileDataToRemove', this.fileDataToRemove)
      //hide dialog
      this.removeFileDialog = false
      //show loader
      this.loader = true
      //set config for axios request with Authorization header
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      //compose delete
      let id = this.fileDataToRemove.qdfData_ar[this.fileDataToRemove.index].id
      let url = this.url_composeApiUrl('/driver/delete-file-' + this.fileDataToRemove.mode + '/' + id)
      axios.delete(url, config)
        .then(response => {
          console.log('delete response', response)
          this.loader = false
          if (response.data.success) {
            //success
            //remove chip
            this.fileDataToRemove.qdfData_ar.splice(this.fileDataToRemove.index, 1);
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            //still logged in
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          this.loader = false
          snackBarBus.$emit('message', error.toString())
        })
    }
  },
  mounted() {
    switch (this.mode) {
      case 'matching':
        //init newFileRows
        for (let qualificationAreaData of this.data.qualificationAreaData_ar) {
          if (qualificationAreaData.hasFileUpload) {
            this.ensureNewFileInputRow(this.newFileRows[qualificationAreaData.id])
          }
        }
        break
    }
  },
  created() {
  }
}
</script>

<style>
</style>